import useGetShapeSvg from "@/composables/2dEditor/useGetShapeSvg";

import { generateId } from "@/utils/common";

import customFabric from '@/fabric/index'
const { createFabricObject } = customFabric

/**
 * Payload can be either a string or an object.
 * If it's a string, it's the objectType of the shape.
 * If it's an object, it's the shape object.
 *
 * If it's a string, we fetch the SVG string of the shape
 * and create a new shape object.
 *
 * If it's an object, we return the object as is and use loadFromJSON
 *
 * @param {String|Object} payload
 * @returns {Promise}
 */
export async function useCreateEditorShape(payload) {
  if (!payload) {
    throw new Error('useCreateEditorShape: payload is required')
  }

  // Adding existing object
  if (typeof payload !== 'string') {
    return createFabricObject(payload)
  }

  // Adding new object
  const shapeSvgString = await useGetShapeSvg(payload);
  const shapeObject = {
    _new: true,
    objectType: payload,
    id: `obj-${generateId()}`,
    svg: shapeSvgString
  }

  return createFabricObject(shapeObject)
}
